import requests from '@opendoor/shared-fe/build/store/requests';
import session from '@opendoor/shared-fe/build/store/session';
import { connectRouter } from 'connected-react-router';

import { api } from './api';
import experimentFlags from './experimentFlags';
import featureFlags from './featureFlags';
import flow from './flow';
import flow_ng from './flow_ng';
import { httpApi } from './httpApi';
import reducer from './sellerFlow/reducer';
import sellerInput from './sellerInput';
import ui from './ui';

export type ReduxState = {
  [K in keyof ReturnType<typeof createReducers>]: ReturnType<ReturnType<typeof createReducers>[K]>;
};

const createReducers = (history: any) => ({
  requests: requests.reducer,
  router: connectRouter(history),
  sellerFlow: reducer,
  session: session.reducer,

  [api.reducerPath]: api.reducer,
  [httpApi.reducerPath]: httpApi.reducer,
  sellerInput,
  featureFlags,
  experimentFlags,
  flow,
  flow_ng,
  ui,
});

export default createReducers;
